/* Coiny Minds storefront enhancements. Native Shopify forms remain the no-JS fallback. */
(() => {
  'use strict';
  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealGalleryImage = (gallery) => {
    const photo = gallery.querySelector('[data-cm-zoom]');
    if (!photo) return;
    const rect = photo.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    const viewport = window.visualViewport;
    const header = document.querySelector('.cm-header-section');
    const top = Math.max(viewport?.offsetTop || 0, header?.getBoundingClientRect().bottom || 0);
    const bottom = Math.min(window.innerHeight, (viewport?.offsetTop || 0) + (viewport?.height || window.innerHeight));
    if (bottom <= top) return;
    if (rect.top >= top && rect.bottom <= bottom) return;
    const gap = rect.height > bottom - top ? 12 : Math.min(12, (bottom - top - rect.height) / 2);
    let movement = 0;
    if (rect.height > bottom - top || rect.top < top) movement = rect.top - top - gap;
    else if (rect.bottom > bottom) movement = rect.bottom - bottom + gap;
    if (Math.abs(movement) > 1) window.scrollBy({top: movement, behavior: prefersReducedMotion() ? 'auto' : 'smooth'});
  };
  const revealGalleryThumb = (thumb) => {
    const strip = thumb.closest('.cm-gallery-thumbs');
    if (!strip) return;
    const bounds = strip.getBoundingClientRect();
    const item = thumb.getBoundingClientRect();
    const movement = item.left < bounds.left ? item.left - bounds.left : item.right > bounds.right ? item.right - bounds.right : 0;
    if (Math.abs(movement) > 1) strip.scrollBy({left: movement, behavior: prefersReducedMotion() ? 'auto' : 'smooth'});
  };
  const setDetailZoom = (dialog, expanded) => {
    dialog.classList.toggle('cm-detail-zoom', expanded);
    const control = dialog.querySelector('[data-cm-toggle-zoom]');
    if (control) {
      control.setAttribute('aria-pressed', String(expanded));
      control.textContent = expanded ? 'Fit to window' : 'View full size';
    }
  };
  document.addEventListener('click', (event) => {
    const gallery = event.target.closest('[data-cm-gallery]');
    const thumb = event.target.closest('[data-cm-thumb]');
    if (gallery && event.target.closest('[data-cm-prev], [data-cm-next]')) {
      const thumbs = [...gallery.querySelectorAll('[data-cm-thumb]')];
      const current = thumbs.findIndex(el => el.getAttribute('aria-pressed') === 'true');
      const direction = event.target.closest('[data-cm-next]') ? 1 : -1;
      const next = thumbs[(current + direction + thumbs.length) % thumbs.length];
      if (next) {
        next.click();
        revealGalleryThumb(next);
      }
    }
    if (event.target.closest('[data-cm-toggle-zoom], [data-cm-detail-zoom]')) {
      const dialog = event.target.closest('dialog');
      const detail = dialog?.querySelector('[data-cm-detail-zoom]');
      if (dialog && detail?.naturalWidth) setDetailZoom(dialog, !dialog.classList.contains('cm-detail-zoom'));
    }
    if (gallery && thumb) {
      const main = gallery.querySelector('[data-cm-main-image]');
      if (thumb.dataset.srcset) main.srcset = thumb.dataset.srcset;
      else main.removeAttribute('srcset');
      main.src = thumb.dataset.src;
      main.alt = thumb.dataset.caption;
      if (Number(thumb.dataset.width) > 0 && Number(thumb.dataset.height) > 0) {
        main.width = Number(thumb.dataset.width);
        main.height = Number(thumb.dataset.height);
        if (gallery.dataset) gallery.dataset.cmRatio = Number(thumb.dataset.width) > Number(thumb.dataset.height) ? 'landscape' : 'portrait';
      }
      gallery.querySelector('[data-cm-zoom]').href = thumb.dataset.full;
      gallery.querySelector('[data-cm-caption]').textContent = thumb.dataset.caption;
      const thumbs = [...gallery.querySelectorAll('[data-cm-thumb]')];
      thumbs.forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
      const count = gallery.querySelector('[data-cm-count]');
      if (count) count.textContent = `${thumbs.indexOf(thumb) + 1} / ${thumbs.length}`;
      window.requestAnimationFrame(() => revealGalleryImage(gallery));
    }
    if (gallery && event.target.closest('[data-cm-zoom]')) {
      const dialog = gallery.querySelector('dialog');
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        const main = gallery.querySelector('[data-cm-main-image]');
        const image = dialog.querySelector('img');
        const zoomControl = dialog.querySelector('[data-cm-toggle-zoom]');
        if (zoomControl) zoomControl.disabled = true;
        dialog.style.removeProperty('--cm-image-natural-width');
        image.onload = () => {
          dialog.style.setProperty('--cm-image-natural-width', `${image.naturalWidth}px`);
          image.width = image.naturalWidth;
          image.height = image.naturalHeight;
          if (zoomControl) zoomControl.disabled = false;
        };
        image.src = gallery.querySelector('[data-cm-zoom]').href;
        image.alt = main.alt;
        if (image.complete && image.naturalWidth) image.onload();
        setDetailZoom(dialog, false);
        dialog.showModal();
      }
    }
    if (event.target.closest('[data-cm-close]')) event.target.closest('dialog')?.close();
    const toggle = event.target.closest('.cm-menu-button');
    const menu = document.getElementById('cm-mobile-menu');
    if (toggle && menu) {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      toggle.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
      menu.hidden = open;
    }
    if (event.target.closest('#cm-mobile-menu a') && menu) {
      menu.hidden = true;
      const button = document.querySelector('.cm-menu-button');
      button?.setAttribute('aria-expanded', 'false');
      button?.setAttribute('aria-label', 'Open menu');
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.getElementById('cm-mobile-menu');
    if (menu && !menu.hidden) {
      menu.hidden = true;
      const button = document.querySelector('.cm-menu-button');
      button?.setAttribute('aria-expanded', 'false');
      button?.setAttribute('aria-label', 'Open menu');
      button?.focus();
    }
  });
  let adding = false;
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.cm-add-form');
    if (!form || !window.fetch || form.hasAttribute('data-preview-form')) return;
    event.preventDefault();
    // Keep legacy cart integrations from intercepting these dedicated forms.
    event.stopImmediatePropagation();
    if (adding) return;
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('.cm-form-status');
    if (button.disabled) return;
    adding = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = 'Adding to your bag…';
    delete status.dataset.error;
    const drawer = document.querySelector('cart-drawer');
    const body = new FormData(form);
    if (drawer) {
      body.set('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
      body.set('sections_url', window.location.pathname);
      if (!drawer.classList.contains('active')) drawer.setActiveElement(button);
    }
    let added = false;
    try {
      const response = await fetch(window.routes.cart_add_url, { method: 'POST', headers: { 'Accept': 'application/json' }, body });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'This item could not be added. Please try again.');
      added = true;
      status.textContent = 'Added to your bag.';
      if (drawer && result.sections && Object.values(result.sections).every(Boolean)) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(result);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'coiny-minds', cartData: result });
      } else {
        window.location.assign(window.routes.cart_url);
      }
    } catch (error) {
      if (added) {
        window.location.assign(window.routes.cart_url);
      } else {
        status.dataset.error = 'true';
        status.textContent = error.message || 'We could not update your bag. Please try again.';
      }
    } finally {
      adding = false;
      button.disabled = added && Boolean(form.closest('.cm-upsell'));
      if (button.disabled) button.querySelector('span').textContent = 'Added to your bag';
      button.removeAttribute('aria-busy');
    }
  }, true);
  // Hide native fallback navigation only after its event handlers are ready.
  document.documentElement.classList.add('cm-enhanced');
  const header = document.querySelector('.cm-header-section');
  if (header) {
    const measureHeader = () => document.documentElement.style.setProperty('--cm-header-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
    measureHeader();
    if (window.ResizeObserver) new ResizeObserver(measureHeader).observe(header);
    else window.addEventListener('resize', measureHeader, {passive:true});
  }
})();

// A single explicit cart update exchanges the original item for the existing set.
document.addEventListener('submit', async event => {
  const form = event.target.closest('.cm-upgrade-form');
  if (!form || form.hasAttribute('data-preview-form') || !window.fetch) return;
  event.preventDefault(); event.stopImmediatePropagation();
  const button = form.querySelector('button');
  if (button.disabled) return;
  button.disabled = true; button.setAttribute('aria-busy','true');
  const status = form.querySelector('[role="status"]');
  status.textContent = 'Updating your bag…';
  try {
    const response = await fetch(form.action + '.js', {method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || 'Please review your bag and try again.');
    window.location.assign(window.routes.cart_url);
  } catch(error) {
    status.textContent = error.message || 'Please review your bag before trying again.';
    button.disabled = false; button.removeAttribute('aria-busy');
  }
}, true);
